import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	inviteRecommendationsFromSlack: {
		id: 'spa-apps-people-profiles.invite-recommendations-from-slack',
		defaultMessage: '{email} (Found in slack)',
		description: 'Tooltip for invite recommendations from Slack',
	},
});
